var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427321340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M2.15022 0.0165193L10.4997 8.3333L8.83312 9.99993L0.567148 1.7339L2.15022 0.0165193Z",
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M10.4832 1.65047L2.16651 10.0001L0.499892 8.33343L8.76586 0.0673928L10.4832 1.65047Z",
    fill: "#B8C5CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/CrossMark.a15fd6a9b21aee46e4da824cca2e9784.svg";
export { ForwardRef as ReactComponent };